<div class="app-input app-select">
    @if (label) {
        <mat-label [class]="required ? 'required-field' : ''">{{ label | translate }}</mat-label>
    }
    <mat-form-field appearance="outline" [class]="disabled ? 'mat-mdc-form-field-disabled' : ''">
        <mat-select
            [placeholder]="placeholder | translate"
            [value]="value"
            [formControl]="control"
            [required]="required"
            [multiple]="multiSelect"
            (selectionChange)="afterSelectionChange.emit($event)"
            [panelClass]="'selectbox-white-panel'"
        >
            @if (isNoneRequired) {
                <mat-option>None</mat-option>
            }
            @for (option of optionsList; track $index) {
                <mat-option [value]="getName ? option[getName] : option">{{ (displayName ? option[displayName] : option) | translate }}</mat-option>
            }
        </mat-select>

        @if (iconPosition.right) {
            <img class="icon" [src]="iconPosition.right" alt="icon" matSuffix (click)="afterIconClick.emit('right')" />
        }
        @if (iconPosition.left) {
            <img class="icon" [src]="iconPosition.left" alt="icon" matPrefix (click)="afterIconClick.emit('left')" />
        }

        @if (control.invalid) {
            <mat-error>{{ getErrorMessage() | translate }}</mat-error>
        }
    </mat-form-field>
</div>
